// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bg1-","label":"styles_label__1nw_w"};